const bankNav =  [
    {
        route: 'admin.setting.branch',
        icon: 'cluster',
        text: 'Cabang'
    }, {
        route: 'admin.setting.division',
        icon: 'number',
        text: 'Divisi'
    }, {
        route: 'admin.setting.training',
        icon: 'property-safety',
        text: 'Pelatihan'
    }
]

export default bankNav
